import React from "react";
import "./HRCopilotStatsSection.css";

export default function HRCopilotStatsSection() {
  const stats = [
    {
      number: "95%",
      label: "Client Success",
      description:
        "Seamlessly onboard new hires with automated workflows and personalized experiences.",
    },
    {
      number: "1,200+",
      label: "Employees Onboarded",
      description:
        "Efficiently process and integrate talent through our intelligent onboarding platform.",
    },
    {
      number: "250+",
      label: "Companies Served",
      description:
        "Transform HR operations with scalable onboarding solutions tailored to your needs.",
    },
    // {
    //   number: "40+",
    //   label: "Industry Awards",
    //   description:
    //     "Recognized excellence in revolutionizing employee onboarding and HR automation.",
    // },
  ];

  return (
    <section className="stats-section">
      <div className="stats-header">
        <p className="stats-subtitle">OUR SUCCESSES OVER THE YEARS</p>

        <h2 className="stats-title">
          <span>Stats talk</span>
          <span className="highlight">For themselves</span>
        </h2>

        <p className="stats-description">
          HR Copilot transforms HR operations using AI, helping companies automate hiring,
          streamline onboarding, and scale with precision. Our results speak for themselves.
        </p>
      </div>

      <div className="stats-grid">
        {stats.map((stat, index) => (
          <div className="stats-card" key={index}>
            <div className="stat-circle">
              <h3 className="stats-number">{stat.number}</h3>
            </div>

            <h4 className="stat-label">{stat.label}</h4>
            <div className="stat-underline"></div>
            <p className="stat-text">{stat.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
